var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackButtom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.47047 18.9271C7.57956 18.9271 7.13339 20.0042 7.76336 20.6342L18.5241 31.395C18.9147 31.7855 18.9147 32.4187 18.5241 32.8092L17.7071 33.6262C17.3166 34.0167 16.6834 34.0167 16.2929 33.6262L0.707107 18.0404C0.316582 17.6499 0.316582 17.0167 0.707107 16.6262L16.2929 1.04043C16.6834 0.649911 17.3166 0.649911 17.7071 1.04044L18.5241 1.85747C18.9147 2.248 18.9147 2.88116 18.5241 3.27169L7.76336 14.0325C7.13339 14.6624 7.57956 15.7396 8.47046 15.7396H33C33.5523 15.7396 34 16.1873 34 16.7396V17.9271C34 18.4794 33.5523 18.9271 33 18.9271H8.47047Z",
    fill: "#3B147A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButtom);
export default __webpack_public_path__ + "static/media/backButtom.7e672bd11ff96e29b0e8a540e45839f6.svg";
export { ForwardRef as ReactComponent };